import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ParentRouteProps {
  children: React.ReactNode;
}

export const ParentRoute = ({ children }: ParentRouteProps): JSX.Element => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.user_type?.name !== 'parent') {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default ParentRoute;
